import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { sortOptions } from "../../../config"
export default function SelectSort() {
    const { loading, query, response, pageType } = useAppState()
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        console.log('sort', event.target.value)
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return (
        <div className="flex align-items-center">
            <label htmlFor="select-sort" className="select-sort-label">Sort by:</label>
            <select onChange={(event) => handleSortChange(event)} id="select-sort" className="select-sort" name="sort">
                {options.map(option => 
                    <option key={option.value} value={option.value} selected={option.value === activeSort}>
                        {option.label}
                    </option>
                )}
            </select>
        </div>
    )
}